export default [
  {
    position: "absolute",
    top: 9,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "policies.persona1.ttTextOne",
    hover: false,
    id: "OB_Policies_Navigation_Homepage",
    index: 0,
  },
  {
    position: "absolute",
    top: 6.1,
    left: 32.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "policies.persona1.ttTextTwo",
    hover: false,
    id: "OB_Policies_Navigation_PersonalDetails",
    index: 1,
  },
  {
    position: "absolute",
    top: 6.1,
    left: 69.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "policies.persona1.ttTextThree",
    hover: false,
    id: "OB_Policies_Navigation_Feedback",
    index: 2,
  },
  {
    position: "absolute",
    top: 0.8,
    left: 87,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "policies.persona1.ttTextFour",
    hover: false,
    tooltipClass: "left",
    id: "OB_Policies_Navigation_Actions",
    index: 3,
  },
  {
    position: "absolute",
    top: 46.5,
    left: 16.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "policies.persona1.ttTextFive",
    hover: false,
    id: "OB_Policies_Navigation_StaffHandbook",
    index: 4,
  },
];
